
(function () {
    "use strict";

    angular
        .module("Agnes")

        //
        .controller("MessageBoxController", [
            "$scope", "title", "text", "buttonText",
            function ($scope, title, text, buttonText) {

                $scope.title = title;
                $scope.text = text;
                $scope.buttonText = buttonText;

                $scope.buttonClick = function () {
                    $scope.$close();
                };
            }
        ]);

})();